import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild} from '@angular/core';
import {SelectableNavigationItem} from '../../../../model/selectable-navigation-item';
import {PageNames} from '../../../../shared/page-names.enum';
import {NavigationService} from '../../../../services/navigation/navigation.service';
import {KeyDirections} from '../../../../shared/key-directions.enum';

@Component({
  selector: 'app-input-pincode',
  templateUrl: './input-pincode.component.html',
  styleUrls: ['./input-pincode.component.less']
})
export class InputPincodeComponent extends SelectableNavigationItem implements OnChanges, AfterViewInit {
  @ViewChild('pin', {read: ElementRef})
  pin: ElementRef;

  @Output()
  emitPin = new EventEmitter<Object>();
  @Output()
  emitPinRemoved = new EventEmitter<Object>();
  @Output()
  emitOnBack = new EventEmitter<Object>();
  @Input()
  pincodeIncorrect: boolean;

  constructor(private navigationService: NavigationService) {
    super();
  }

  ngAfterViewInit(): void {
    this.navigationService.registerNavigation(this, PageNames.PINCODE_MODAL);
  }

  onEnter(): void {
  }

  activate(active: boolean): void {
    this.active = active;
    if (active) {
      if (this.pin.nativeElement.value) {
        this.emitPinRemoved.emit({pin: this.pin.nativeElement.value});
        this.pin.nativeElement.value = '';
      }
      this.pin.nativeElement.focus();
    }
  }

  onInput(event): void {
    if (!isNaN(event.value)) {
      this.emitPin.emit({
        pin: event.value
      });
    } else {
      this.pin.nativeElement.value = '';
    }
  }

  canNavigateToDirection(keyCode: number): boolean {
    return this.pin.nativeElement.value || this.x <= 3 || keyCode !== KeyDirections.ARROW_RIGHT;
  }

  containsValue(): boolean {
    return this.pin.nativeElement.value !== '';
  }

  ngOnChanges(changes): void {
    if (changes.pincodeIncorrect.currentValue) {
      this.pin.nativeElement.value = '';
    }
  }

  onBack(): void {
    this.emitOnBack.emit({
      value: true
    });
  }

}

